<template>
    <div
        @click="$emit('click')"
		class="rp-custom-card"
		>
		<div class="rp-custom-card__header" v-if="isheader">
            <slot name="header">
                {{ header }}
            </slot>
            <slot name="subHeader">
                <div v-if="subHeader" class="rp-custom-card__header__sub">{{ subHeader }}</div>
            </slot>
            <hr v-if="hrForBorder" class="rp-custom-card__header____border"/>
		</div>
        <div class="rp-custom-card__body"> 
			<slot name="body">
                Hello
            </slot>
		</div>
		<div class="rp-custom-card__footer">
		</div>
	</div> 
</template>
<script>
export default {
    props: {
        header: {
            type: String,
            default: 'Hello',
        },
        hrForBorder: {
            type: Boolean,
            default: false
        },
        subHeader: {
            type: String,
            default: '',
        },
        isheader: {
            type: Boolean,
            default: true
        }
    }
}
</script>
<style lang="scss" scoped>
    .rp-custom-card {
        border-radius: 7px;
        background: #fff;
        box-shadow: 0 4px 15px 0 rgba(22, 11, 11, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.1), inset 0 2px 0 0 rgba(255, 255, 255, 0.5);
        .rp-custom-card__header {
            border-bottom: 1px solid #eeeeee;
            padding: 15px 20px;
            font-size: 18px;
            background: #f9f9f9;
            font-weight: 400;
            border-top-right-radius: 4px;
            border-top-left-radius: 4px;
            line-height: 1;
            @include for-size(tablet-landscape-up){ 
                font-size: 26px;
                padding: 20px 40px;
                line-height: $lineHeight;
            }
            @include for-size(desktop-up){
                padding: $desktopPadding;
                font-size: 26px;
                line-height: $lineHeight;
            }
            .rp-custom-card__header____border {
                border-bottom: 0.1px solid #e5e5e5;
                margin-block-start: 1rem !important;
                margin-block-end: 1rem !important;
            }
            .rp-custom-card__header__sub {
                font-size: 14px;
                color: #999;
                line-height: 1.5;
                @include for-size(desktop-up){
                    font-size: 18px;
                }
            }
        }
        .rp-custom-card__body {

        }

        .rp-custom-card__footer {

        }
    }
</style>